import type { SVGProps } from "react";
import CheckIcon from "./CheckIcon";
import CheckIcon2 from "./CheckIcon2";
import ChevronDownIcon from "./ChevronDownIcon";
import CrossIcon from "./CrossIcon";
import DatabaseIcon from "./DatabaseIcon";
import DownloadIcon from "./DownloadIcon";
import EyeIcon from "./EyeIcon";
import GoldKeyIcon from "./GoldKeyIcon";
import KeyIcon from "./KeyIcon";
import OrganizationIcon from "./OrganizationIcon";
import PencilIcon from "./PencilIcon";
import PencilIcon2 from "./PencilIcon2";
import PlayIcon from "./PlayIcon";
import PlusIcon from "./PlusIcon";
import RelationshipIcon from "./RelationshipIcon";
import ResetIcon from "./ResetIcon";
import SaveIcon from "./SaveIcon";
import TrashIcon from "./TrashIcon";

// TODO: v2 icon, remove old ones or merge them with these

export type IconType =
  | "plus"
  | "trash"
  | "pencil"
  | "check"
  | "cross"
  | "chevron-down"
  | "check2"
  | "pencil2"
  | "eye"
  | "key"
  | "gold-key"
  | "database"
  | "save"
  | "download"
  | "reset"
  | "play"
  | "organization"
  | "relationship";

export type IconBaseProps = SVGProps<SVGSVGElement>;

export interface IconProps extends IconBaseProps {
  name: IconType;
  width?: number;
  height?: number;
}

export default function Icon({ name, ...otherProps }: IconProps) {
  if (name === "plus") return <PlusIcon {...otherProps} />;
  if (name === "trash") return <TrashIcon {...otherProps} />;
  if (name === "pencil") return <PencilIcon {...otherProps} />;
  if (name === "check") return <CheckIcon {...otherProps} />;
  if (name === "cross") return <CrossIcon {...otherProps} />;
  if (name === "chevron-down") return <ChevronDownIcon {...otherProps} />;
  if (name === "check2") return <CheckIcon2 {...otherProps} />;
  if (name === "pencil2") return <PencilIcon2 {...otherProps} />;
  if (name === "eye") return <EyeIcon {...otherProps} />;
  if (name === "key") return <KeyIcon {...otherProps} />;
  if (name === "gold-key") return <GoldKeyIcon {...otherProps} />;
  if (name === "database") return <DatabaseIcon {...otherProps} />;
  if (name === "save") return <SaveIcon {...otherProps} />;
  if (name === "relationship") return <RelationshipIcon {...otherProps} />;
  if (name === "download") return <DownloadIcon {...otherProps} />;
  if (name === "play") return <PlayIcon {...otherProps} />;
  if (name === "reset") return <ResetIcon {...otherProps} />;
  if (name === "organization") return <OrganizationIcon {...otherProps} />;
  return <PlusIcon {...otherProps} />;
}
